module.exports = __webpack_public_path__ + "img/progetti_emt.34204061.png";